import { useEffect, useRef } from 'react';

export default function Hero() {
  const heroRef = useRef(null);

  useEffect(() => {
    const el = heroRef.current;
    if (!el) return;
    const children = el.querySelectorAll('.hero-animate');
    children.forEach((child, i) => {
      setTimeout(() => {
        child.style.opacity = '1';
        child.style.transform = 'translateY(0)';
      }, 300 + i * 200);
    });
  }, []);

  const handleScroll = (e, target) => {
    e.preventDefault();
    document.querySelector(target)?.scrollIntoView({ behavior: 'smooth' });
  };

  const createRipple = (e) => {
    const btn = e.currentTarget;
    const circle = document.createElement('span');
    const diameter = Math.max(btn.clientWidth, btn.clientHeight);
    const radius = diameter / 2;
    circle.style.width = circle.style.height = `${diameter}px`;
    circle.style.left = `${e.clientX - btn.offsetLeft - radius}px`;
    circle.style.top = `${e.clientY - btn.offsetTop - radius}px`;
    circle.classList.add('ripple-effect');
    btn.appendChild(circle);
    setTimeout(() => circle.remove(), 600);
  };

  return (
    <section
      id="inicio"
      ref={heroRef}
      data-testid="hero-section"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
      style={{
        background: 'linear-gradient(135deg, #1A8C7A 0%, #0f6b5c 40%, #0a4f44 100%)',
      }}
    >
      {/* Animated wave background */}
      <div className="absolute inset-0 overflow-hidden pointer-events-none">
        {/* Floating circles */}
        <div className="absolute top-20 left-10 w-32 h-32 rounded-full bg-white/5 animate-pulse" style={{ animationDuration: '4s' }} />
        <div className="absolute top-40 right-20 w-48 h-48 rounded-full bg-white/3 animate-pulse" style={{ animationDuration: '6s' }} />
        <div className="absolute bottom-40 left-1/4 w-24 h-24 rounded-full bg-[#E8621A]/10 animate-pulse" style={{ animationDuration: '5s' }} />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 text-center pt-20">
        <p
          className="hero-animate text-[#E8621A] font-bold text-sm sm:text-base tracking-[0.2em] uppercase mb-4 sm:mb-6"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'all 0.8s ease' }}
        >
          SINDPESCA — PA / AP
        </p>

        <h1
          className="hero-animate text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-extrabold text-white leading-tight mb-4 sm:mb-6"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'all 0.8s ease', letterSpacing: '-0.02em' }}
        >
          A FORÇA DO SINDPESCA
          <br />
          <span className="text-[#E8621A]">VEM DAS ÁGUAS</span>
        </h1>

        <p
          className="hero-animate text-base sm:text-lg text-white/80 font-light max-w-2xl mx-auto mb-3"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'all 0.8s ease' }}
        >
          Sindicato dos Pescadores e Pescadoras Artesanais do Estado do Pará e Amapá
        </p>

        <p
          className="hero-animate text-sm sm:text-base text-white/70 font-light max-w-xl mx-auto mb-8 sm:mb-10 italic"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'all 0.8s ease' }}
        >
          "O SINDPESCA ajuda a proteger nossas águas e peixes para as gerações futuras."
        </p>

        <div
          className="hero-animate flex flex-col sm:flex-row items-center justify-center gap-4"
          style={{ opacity: 0, transform: 'translateY(30px)', transition: 'all 0.8s ease' }}
        >
          <a
            href="#cadastro"
            onClick={(e) => handleScroll(e, '#cadastro')}
            onMouseDown={createRipple}
            data-testid="hero-cta-cadastro"
            className="btn-ripple inline-flex items-center gap-2 px-8 py-4 bg-[#E8621A] text-white font-bold
              rounded-full text-sm sm:text-base shadow-lg hover:bg-[#D05515] hover:-translate-y-1
              transition-all duration-300"
          >
            <i className="fas fa-clipboard-list"></i>
            PARTICIPE — Cadastre-se Agora
          </a>
          <a
            href="#sobre"
            onClick={(e) => handleScroll(e, '#sobre')}
            data-testid="hero-cta-saiba"
            className="inline-flex items-center gap-2 px-8 py-4 border-2 border-white/80 text-white font-semibold
              rounded-full text-sm sm:text-base hover:bg-white hover:text-[#1A8C7A]
              transition-all duration-300"
          >
            Saiba Mais
            <i className="fas fa-arrow-right"></i>
          </a>
        </div>
      </div>

      {/* Wave bottom divider */}
      <div className="absolute bottom-0 left-0 w-full">
        <svg viewBox="0 0 1440 120" fill="none" xmlns="http://www.w3.org/2000/svg" className="w-full" preserveAspectRatio="none">
          <path d="M0,64 C360,120 720,0 1080,64 C1260,96 1380,80 1440,64 L1440,120 L0,120 Z" fill="#ffffff" />
          <path d="M0,80 C320,120 640,40 960,80 C1120,100 1320,60 1440,80 L1440,120 L0,120 Z" fill="#ffffff" opacity="0.5" />
        </svg>
      </div>

      {/* Scroll indicator */}
      <div
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10"
        style={{ animation: 'scroll-bounce 2s infinite' }}
      >
        <div className="w-6 h-10 border-2 border-white/50 rounded-full flex justify-center pt-2">
          <div className="w-1 h-3 bg-white/70 rounded-full animate-pulse" />
        </div>
      </div>
    </section>
  );
}
